<mat-card class="cardWithShadow">
    <mat-card-content>
        <div class="container_button_company" style="margin-bottom: 15px;">
            <mat-card-title>CRM - Tratos</mat-card-title><br>
            <mat-card-title>{{estadoTratoMostrar}} / {{estadoResolutivoMostrar}}</mat-card-title>
        </div>

        <div style="text-align: center;" *ngIf="dataSource.data.length == 0 && booleanFlag == false">
            <h3>No Se Encontararon Tratos</h3>
        </div>

        <div class="overflow-table" [ngClass]="{ oculto: dataSource.data.length == 0 }">
            <table mat-table matSort (matSortChange)="changeSorting($event)" [dataSource]="dataSource">

                <ng-container matColumnDef="companyName">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Cliente
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.companyName }}</h6>
                        <h6>{{ element.companyRut | rutChilenoDv }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="finalidad">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Finalidad
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.finalidad }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Acción
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.name }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="executiveName">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Ejecutivo
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.executiveName }}</h6>
                    </td>
                </ng-container>
                
                <ng-container matColumnDef="fechaCreacion">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Fecha Crea.
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.fechaCreacion | date : 'dd/MM/yyyy' }}</h6>
                        <h6>{{ element.fechaCreacion | date : "shortTime" }} Hrs.</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="ultimaFecha">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Fecha Act.
                    </th>
                    <td mat-cell *matCellDef="let element" [ngClass]="{ 'bg-rojo': esMayorA4Horas(element.ultimaFecha) && (element.ultimoEstado==0 || element.ultimoEstado==3) }">
                        <h6>{{ element.ultimaFecha | date : 'dd/MM/yyyy' }}</h6>
                        <h6>{{ element.ultimaFecha | date : "shortTime" }} Hrs.</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="dealAmount">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Monto
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.dealAmount | currency: 'CLP' }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="comision">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Comisión
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.comision | currency : 'CLP' }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="tags">
                    <th class="th-header" mat-header-cell *matHeaderCellDef>
                        Etiquetas
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <span *ngFor="let tag of element.tags">
                            <mat-chip style="font-size: small; font-weight: bold; background-color: rgba(18, 79, 211, 0.385);">{{ tag }}</mat-chip>
                        </span>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayCols"></tr>
                <tr mat-row [cdkContextMenuTriggerFor]="menu" *matRowDef="let row; columns: displayCols" class="cursor-table" style="cursor: pointer;" (click)="openModalDetaiDeals(row)">

                    <ng-template #menu>
                        <div cdkMenu class="context_menu mat-elevation-z0" style="z-index: 999">
                            <span>
                                <button color="primary"
                                class="context-menu-item"
                                cdkMenuItem
                                mat-flat-button
                                (click)="redirectDashbardClient(row.companyRut)"
                                >
                                    Ver Cliente
                                </button><br>
                                <button
                                class="context-menu-item"
                                cdkMenuItem
                                mat-flat-button
                                (click)="redirectDealCRM(row.id)"
                                >
                                    Ver en CRM
                                </button>
                            </span>
                        </div>
                    </ng-template>
                </tr>
            </table>
        </div>
        <div>
            <mat-paginator (page)="changePagination($event)" [pageSizeOptions]="[5, 10, 20, 100]"></mat-paginator>
        </div>
    </mat-card-content>
</mat-card>